module.exports = __webpack_public_path__ + "img/photo-0072.08acc114.jpg";